<template>
    <div class="content-box" :class="{'content-collapse':collapse}" ref="main">
        <div class="content">
            <slot></slot>
        </div>
    </div>
</template>

<script>

  export default {
    name: 'app-content',
    data() {
      return {
        collapse: false
      }
    },
    components: {},
    created() {
      bus.$on('collapse', msg => {
        this.collapse = msg;
      })
    },
    mounted() {
      bus.$on('top0', () => {
        this.$refs.main.scrollTop = 0;
      })
    }
  }
</script>
